import { Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SuccessBucketIcon } from '../../../icons';
import { Page } from './Page';

export const FinalStep = () => {
  const { t } = useTranslation(['forms']);

  return (
    <Page>
      <Stack pb={24} spacing="xl" align="center">
        <Stack align="center">
          <Text>
            <SuccessBucketIcon size={40} />
          </Text>
          <Text fz="xl" fw={600}>
            {t('external.successTitle')}
          </Text>
        </Stack>
        <Stack spacing={0} align="center">
          <Text fw={500}>{t('external.fromSubmittedLine1')}</Text>
          <Text fw={500}>{t('external.fromSubmittedLine2')}</Text>
        </Stack>
      </Stack>
    </Page>
  );
};
